import { render, staticRenderFns } from "./BooksSelector.vue?vue&type=template&id=b3f87186&scoped=true"
import script from "./BooksSelector.vue?vue&type=script&lang=js"
export * from "./BooksSelector.vue?vue&type=script&lang=js"
import style0 from "./BooksSelector.vue?vue&type=style&index=0&id=b3f87186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f87186",
  null
  
)

export default component.exports